<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <search-form-template
      ref="storeTemplate"
      :searchOptions="storeSearchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      @btnCommon="btnCommon"
    ></search-form-template>
    <div class="searchbox">
     <div class="searchArea">
       <el-radio v-model="radio" :label="1" @change="averageChoose"><div style="display:inline;line-height:30px">均分区间</div>
         <div class="averageArea">
          <input type="number" min="0" v-model="minNum"><span>元</span><input type="number" min="1" v-model="maxNum"><span>元 </span>&nbsp;&nbsp;&nbsp;<span>分</span><input type="number" min="1" v-model="lengthNum"><span>段</span><i>最多可分10段</i>
         </div>
       </el-radio>
    </div>
    <div class="searchArea">
      <el-radio v-model="radio" :label="2" ><div style="display:inline;line-height:30px">自选区间</div>
      <div class="selfArea">
        <input type="number" min="1" v-model="selfSmall"><span>元</span><b style="line-height:30px">—</b><input type="number" min="1" v-model="selfMax"><span>元</span>&nbsp;&nbsp;
        <el-button @click="addCheck">添加</el-button><i>最多可选7段</i>
        <div v-for="(v,i) in addArr" :key="i"><span>{{v[0]}}{{v[1]}}</span></div>
      </div>
      </el-radio>
    </div>
    </div>
    <div class="customlist">
      <!-- 左 -->
      <div class="centerBack">
        <echarts-template class="charts-box" ref="customLeftEcharts"
                          :picOption="customLeftEcharts">
        </echarts-template>

        <list-template
          :tableOptions="leftTableOptions"
          :tableData="leftTableData"
        ></list-template>
      </div>
      <!-- 右 -->
      <div class="centerBack">
        <echarts-template class="charts-box" ref="customRightEcharts"
                          :picOption="customRightEcharts">
        </echarts-template>
        <div class="columTable">
          <table border="1">
            <tr v-for="(v,i) in rightTable" :key="i">
              <td>{{v.memberCategoryName}}</td>
              <td>{{v.amountReceived}}</td>
            </tr>
          </table>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import api from '@/config/api'
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import echartsTemplate from '@/components/controls/echarts';
  import listTemplate from '@/components/template/listTemplate';
  import {customLeftEcharts, customRightEcharts} from '@/page/home/options/reportEcharts'
  import userPower from "@/mixin/userPower";
  export default {
    mixins: [userPower],
    components: {searchFormTemplate, echartsTemplate, listTemplate},
    data () {
      // let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      // let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      // let defaultParam = { stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
      return {
        addArr:[],
        selfList:[],
        minNum:"",
        maxNum:"",
        lengthNum:'',
        selfSmall:"",
        selfMax:"",
        radio:[],
        avergeList:[],
        //    param: defaultParam,
        customLeftEcharts,
        customRightEcharts,
        leftTableData: [],
        title: '',
        indexShow: false,
        leftTableOptions: {
          indexShow: false,
          columns: [
            {label: '区间', prop: 'sectionData', align: 'center'},
            {label: '人数', prop: 'peopleNum', align: 'center'},
            {label: '占比', prop: 'peopleNumRate', align: 'center'}
          ],
        },
        rightTable: [],
        storeSearchOptions: {
          simple: [
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeIds',
              url:api.system.seStore,
              multiple: true,
              data: [],
              span: 24
            },
             {
              label: '选择日期',
              prop: 'createDttms',
              type: 'datetimeRange',
              dateType: 'datetime',
              span: 24
            },
          ],
        },
      }
    },
    created () {
      this.setStore(this.storeSearchOptions.simple);
        this.custormLeft(this.result),
        this.custormRight(this.result),
        this.getCategortList(this.result)
    },
    mounted () {
      this.title = document.title;
    },
    methods: {
      addCheck(){
         if(this.selfSmall&&this.selfMax){
           this.addArr.push(this.selfSmall,this.selfMax)
           console.log(this.addArr)
         }
      },
      averageChoose(value){
        // console.log(this.minNum,this.maxNum,this.lengthNum)
        // console.log(value)
      },
      //左
      custormLeft (result) {
        let param=Object.assign({},result,{sectionDataList:["2~3"]})
        this.$axios.fetchPost(api.report.guestEcharts, param).then(data => {
          // console.log(data)
          if (data.code == 200) {
            this.leftTableData=data.data
            this.customLeftEcharts.charsOption.series[0].data = [];
            data.data.map((item) => {
              this.customLeftEcharts.charsOption.series[0].data.push({
                value: item.peopleNum,
                name: item.sectionData,
              });
                // this.customLeftEcharts.charsOption.legend.data.push(item.peopleNum);
              if ((data.data.memberCount = 0)) {
                this.customLeftEcharts.charsOption.series[0].data = [];
              }
            });
            this.$nextTick(() => {
              this.$refs.customLeftEcharts.drawpic();
            });
          }
        }).catch(err => {
          this.$message({message: '请求失败！', type: 'error'})
        })
      },
      //右
      custormRight (result) {
        let param=Object.assign({},result,{sectionDataList:["1~50"]})
          this.$axios.fetchPost(api.report.guestCategoryEcharts,param).then(data=>{
            if(data.code==200){
                this.customRightEcharts.charsOption.xAxis[0].data = data.data.memberCategoryName
                this.customRightEcharts.charsOption.series[0].data = data.data.amountReceived
            }
             this.$nextTick(() => {
                 this.$refs.customRightEcharts.drawpic();
            });
        })
       
      },
      getCategortList(result){
          let param=Object.assign({},result,{sectionDataList:["1~50"]})
          this.$axios.fetchPost(api.report.guestCategoryList,param).then(data=>{
            if(data.code==200){
               this.rightTable  = data.data
            }
          })
      },
      searchSubmit (result) {
        if(this.maxNum<this.minNum){
          this.$message({message: '请输入正确区间', type: 'warning'})
          return;
        }
        if(this.maxNum<=0||this.lengthNum<=0 || this.lengthNum&&this.maxNum<=0){
          this.$message({message: '均分期间最大值和分段请输入正整数', type: 'warning'})
          return;
        }
        if(this.lengthNum>10){
           this.$message({message: '最多可分为10段', type: 'warning'})
           return;
        }
        let averageList=[]
        let ss=Math.ceil((this.maxNum-this.minNum)/this.lengthNum)
        console.log(ss)
        // averageList.push(this.minNum,this.maxNum,this.lengthNum)
        // console.log(averageList)
        // result["sectionDataList"]=averageList
        // console.log(result)
        this.custormLeft(result)
        this.custormRight(result)
        this.getCategortList(result)
        // console.log(this.minNum,this.maxNum,this.lengthNum)
        //   const simpleParams = this.$refs.storeTemplate.getSimpleParams();
        //   const complexParams = this.$refs.storeTemplate.getComplexParams();
        //   if(result.stCreateDttm){
        //       const parent = Object.assign({},this.param,simpleParams);
        //       const params = Object.assign({},parent,complexParams);
        //       this.memberCategory(params);
        //   }else{
        //      const params = simpleParams;
        //      this.memberCategory(params);
        //   }
      },

      clearSearch () {
        //   this.memberCategory(this.params)
      },
      btnCommon (btnObj) {
        btnObj.callback && btnObj.callback();
      },
    }
  }
</script>

<style scoped>
  .page-template .centerBack {
    background: #fff;
    border-radius: 8px;
    padding: 25px;
    box-sizing: border-box;
    width: 49.8%;
    display: flex;
    justify-content: space-between;
  }

  .charts-box {
    width: 49.8%;
    height: calc(100vh - 400px);
  }

  .customlist {
    display: flex;
    justify-content: space-between;
  }

  .list-template {
    width: 49.5%;
  }

  .columTable {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 49.5%;

  }

  table {
    width: 100%;
    /* height: 200px; */
    text-align: center;
    border: 1px solid #ccc;

  }

  table tr {
    height: 30px;
  }
  .averageArea{
    display: flex;
    position: absolute;
    top: 0;
    left: 100px;
  }
  input{
    width: 70px;
    border: 1px solid #e9e9e9;
    outline: none;
    border-radius: 3px;
    text-align: center;
    color: blue;
  }
  .searchArea{
    display: flex;
    height: 30px;
    align-items: center;
    margin-left: 30px;
    margin-right: 300px;
    margin-bottom: 15px;
  }
  .averageArea i,.selfArea i{
     font-style: normal;
     font-size: 13px;
     color: #999;
     line-height: 30px;
     margin-left: 10px;
  }

  .averageArea span,.selfArea span{
    display: inline-block;
    width: 30px;
    /* height: 30px; */
    border: 1px solid #efefef;
    background: #e0dddd;
    line-height:30px;
    text-align: center;
    border-radius: 2px;
  }
  .selfArea{
    display: flex;
    position: absolute;
    top: 0;
    left: 100px;
  }
  .searchbox{
    /* display: flex;
    width: 100%; */
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/page/report/member/order/OrderAnalyse.vue